import React, { PropsWithChildren } from 'react';

type ChartCardProps = {
  title: string;
  subtitle?: string;
};

/** Titled container that gives every insight section a consistent frame. */
const ChartCard: React.FC<PropsWithChildren<ChartCardProps>> = ({
  title,
  subtitle,
  children,
}) => (
  <section className="mb-6 rounded-lg border border-emphasis40 p-5">
    <h3 className="heading-20 my-0">{title}</h3>
    {subtitle && <p className="paragraph-20 text-grey mt-1 mb-0">{subtitle}</p>}
    <div className="mt-4">{children}</div>
  </section>
);

export default ChartCard;
